module.exports = __webpack_public_path__ + "static/media/search.f698d280.svg";